export default function OlxForex(props) {
  props.setIsFirstStepValid(true);
  return <div></div>;
}
